export const getURL = () => {
  // In development, use localhost
  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:3000';
  }
  
  // In production, use resumealigned.com
  return 'https://resumealigned.com';
};
